import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { getBankDetails } from "../utils/API/getBankAccounts";
import { useDispatch } from "react-redux";

const useBank = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [accountDetails, setAccountDetails] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const { data } = await getBankDetails(dispatch);
        setAccountDetails(data);
      } catch (error) {
        toast.error(error.message);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  return [loading, accountDetails, setAccountDetails];
};

export default useBank;
